<template>
    <div role="alert" class="v-alert v-notify v-sheet theme--dark v-alert--border v-alert--border-right" :class="[color, { 'show' : show }]">
        <div class="v-alert__wrapper">
            <i aria-hidden="true" class="v-icon notranslate v-alert__icon theme--dark" :class="icon"/>
            <div class="v-alert__content" v-html="text">
            </div>
            <div class="v-alert__border v-alert__border--right"></div>
            <button type="button" class="v-alert__dismissible v-btn v-btn--flat v-btn--icon v-btn--round theme--dark v-size--small" aria-label="Закрыть" @click="destroy">
                <span class="v-btn__content">
                    <i aria-hidden="true" class="v-icon notranslate fas fa-times-circle theme--dark" />
                </span>
            </button>
        </div>
    </div>
</template>

<script>
import store from '../../store'

export default {
    props: {
        text: {
            type: String
        },
        title: {
            default: null
        },
        color: {
            type: String
        },
        timeout: {
            type: Number
        }
    },
    data: () => ({
        show: false
    }),
    computed: {
        icon() {
            switch (this.color) {
                case 'error':
                    return 'fas fa-exclamation-circle'
                case 'warning':
                    return 'fas fa-exclamation-triangle'
                case 'success':
                    return 'fas fa-check-circle'
                default:
                    return 'fas fa-info-circle'
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            const link = this.$el.querySelector('#loginLink')
            if (link) {
                link.onclick = () => {
                    this.$axios.post('/update_token', {
                        mute: true,
                        logError: true
                    }).then(response => {
                        if (response.data.error) {
                            store.dispatch('logout')

                            return
                        }

                        axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`
                        localStorage.setItem('token', response.data.token)
                    }).catch(() => {
                        store.dispatch('logout')
                    }).finally(() => {
                        this.destroy()
                    })
                }
            }
        })

        setTimeout(() => {
            this.show = true
        }, 10)

        if (this.timeout != 0) {
            setTimeout(() => {
                this.destroy()
            }, this.timeout)
        }
    },
    methods: {
        destroy() {
            this.$el.style.opacity = 0
            setTimeout(() => {
                if (this.$el.parentNode) {
                    this.$el.parentNode.removeChild(this.$el)
                }
            }, 300)
            this.$destroy()
        }
    }
}
</script>

<style scope>
.v-notify {
    position: absolute !important;
    top: 15px;
    right: 15px;
    z-index: 800;
    opacity: 0;

}
.v-notify.show {
    animation: fadeIn;
    animation-duration: 1s;
    opacity: 1;
}
</style>


// WEBPACK FOOTER //
// Notify.vue?d657873a